var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consult"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":require("@/assets/images/about-img/Phone.png"),"alt":""}})]),_c('li',[_vm._v("电话咨询")])]),_c('ul',[_c('li',[_c('img',{attrs:{"src":require("@/assets/images/about-img/QRCode.png"),"alt":""}})]),_c('li',[_vm._v("立即咨询")])])])
}]

export { render, staticRenderFns }